module.exports = __webpack_public_path__ + "img/base_hebergements_gite.05008801.svg";